import { Plug } from "../../../icons"
import type { McpServerSummary } from '@lens/types/claude'
import { MiniBarRow } from '../mini-bar-row'

interface Props {
 servers: McpServerSummary[]
}

export function McpServerPanel({ servers }: Props) {
 if (servers.length === 0) {
  return <p className="text-muted-foreground type-body">No MCP server usage detected</p>
 }

 return (
  <div>
   {servers.map((srv) => {
    const maxCalls = srv.tools[0]?.calls ?? 1
    return (
     <div key={srv.server_name} className="border-b border-border/40 py-3 first:pt-0 last:border-b-0">
      <div className="flex items-center justify-between mb-2">
       <span className="inline-flex items-center gap-1.5 type-body text-foreground">
        <Plug className="w-3.5 h-3.5 shrink-0" strokeWidth={1.5} /> {srv.server_name}
       </span>
       <span className="type-body text-muted-foreground">
        {srv.tools.length} tools · {srv.total_calls.toLocaleString()} calls · {srv.session_count} sessions
       </span>
      </div>
      <div className="space-y-1">
       {srv.tools.map((t) => (
        <MiniBarRow
         key={t.name}
         label={t.name}
         value={t.calls}
         width={Math.round((t.calls / maxCalls) * 100)}
         color="rgb(from var(--chart-1) r g b / 0.5)"
         labelWidth="w-32"
         valueWidth="w-12"
        />
       ))}
      </div>
     </div>
    )
   })}
  </div>
 )
}
